import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { makeStyles } from '@material-ui/core/styles';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Grid, Typography, Box, IconButton, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { CircularProgress } from '@material-ui/core';
import DateFnsUtils from "@date-io/date-fns";
import { notify } from '../../../utils';
import { REQUIRED_ERROR, RepeatMode } from '../../../utils/constants';
import { MuiPickersUtilsProvider, DatePicker, TimePicker } from "@material-ui/pickers";
import CancelIcon from '@material-ui/icons/Cancel';
import './event.css'
import { ProjectServices } from '../../../Services/ProjectServices';
import OutlinedSelect from 'Components/OutlinedSelect';
import DateRangePickerModal from './DateRangePickerModal';
import moment from 'moment';
import { formatRequiredLabel } from '../../../utils/labelHelper';

const projectServices = new ProjectServices();

const useStyles = makeStyles((theme) => ({}));

const typeList = ['Event', 'Meeting', 'Public Holiday']
const eventTypeList = ['Assessment', 'Course', 'Apprenticeship']
const courseActivityList = ['Self Pased Learning', 'Virtual Class Project', 'Work Readiness Examination']

const initFormState = { expiryDate: null, title: "", from: null, to: null, project: {}, type: "", eventType: "", url: "", repeat_mode: "", course: {}, courseActivity: "", note: '', typeMode: [] };

export default function EventModal({ open, handleClose, handleSaveEvents, btnLoading }) {

    useStyles();
    const [dateRPOpen, setDateRPOpen] = useState(false);
    const [dateRange, setDateRange] = useState({});
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const [formState, setFormState] = useState({ ...initFormState });
    const [projectList, setProjectList] = useState([]);
    const [assessmentList, setAssessmentList] = useState([]);
    const [coursesList, setCoursesList] = useState([]);
    const [apprenticeshipList, setApprenticeshipList] = useState([]);

    useEffect(() => {
        getLicensesList();
    }, []);

    useEffect(() => {
        setFormState({ ...initFormState });
    }, [open]);

    const getLicensesList = async () => {
        const projectList = await projectServices.getAllLicenseListProject(`project/licenselist`);
        if (projectList && projectList.data) {
            const allProject = projectList && projectList.data.length > 0 ? projectList.data.map(item => {
                return {
                    name: item.project_name,
                    id: item.project_uuid
                }
            }) : [];
            setProjectList(allProject);
        }
    };

    const getAssessmentsList = async (id) => {
        const payload = {
            project_id: id
        }
        const licenseDetails = await projectServices.getLicenseinformation(payload)
        if (licenseDetails.status && licenseDetails.data) {
            const data = licenseDetails.data
            setAssessmentList(data.assessments)
            setApprenticeshipList(data.apprenticeships)
            setCoursesList(data.courses)
        }
    }

    const handleChange = (value, name) => {
        if (name === 'typeMode') {
            setFormState((prevState) => {
                const newState = { ...prevState };
                if (value.target.checked) {
                    newState.typeMode.push(value.target.value);
                } else {
                    let index = newState.typeMode.indexOf(value.target.value);
                    if (index !== -1) {
                        newState.typeMode.splice(index, 1);
                    }
                }
                return newState;
            });
        } else if (name === 'project') {
            if (value === null) {
                setFormState({ ...formState, [name]: {}, eventType: "" });
            } else {
                getAssessmentsList(value.id)
                setFormState({ ...formState, [name]: value });
            }
        } else if (name === "eventType") {
            setFormState({ ...formState, courseActivity: "", course: {}, [name]: value });
        } else {
            setFormState({ ...formState, [name]: value });
        }
    }

    const handleInputChange = (evt) => {
        const { name, value } = evt.target;
        setFormState({ ...formState, [name]: value });
    }

    const handleValidate = () => {
        if (!formState.title || !formState.from || !formState.project.id || !formState.to || !formState.type || !formState.repeat_mode) {
            notify("error", REQUIRED_ERROR);
            return null;
        } else {
            if ((formState.type === 'Meeting' || formState.type === 'Public Holiday') && formState.url === "") {
                notify("error", REQUIRED_ERROR);
                return null;
            } else if (formState.courseActivity === "Virtual Class Project" && formState.url === "") {
                notify("error", REQUIRED_ERROR);
                return null;
            } else if (formState.type === 'Event' && (formState.courseActivity === null || formState.course === null || formState.eventType === "" || Object.keys(formState.course).length === 0)) {
                notify("error", REQUIRED_ERROR);
                return null;
            } else {
                handleSaveEvents({ ...formState, startDate, endDate }, dateRange);
            }
        }
    }

    let listTitle = formState.eventType === 'Assessment' ? 'Assessment' : formState.eventType === 'Apprenticeship' ? 'Apprenticeship' : 'Course'
    let dynamicList = formState.eventType === 'Assessment' ? assessmentList : formState.eventType === 'Apprenticeship' ? apprenticeshipList : coursesList

    return (
        <div>
            <Dialog
                fullWidth={true}
                maxWidth={'sm'}
                PaperProps={{
                    style: { borderRadius: 15 }
                }}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="id">
                    <Box display="flex" alignItems="center">
                        <Box flexGrow={1}>
                            <Typography variant='h4'>Create Event</Typography>
                        </Box>
                        <Box>
                            <IconButton onClick={handleClose}>
                                <CancelIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                value={startDate}
                                type={'text'}
                                label={formatRequiredLabel("Start Date *")}
                                color={'secondary'}
                                variant="outlined"
                                size="small"
                                fullWidth
                                InputProps={{ readOnly: true }}
                                InputLabelProps={{ shrink: true }}
                                onClick={(evt) => {
                                    if (!dateRPOpen) setDateRPOpen(true)
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                value={endDate}
                                type={'text'}
                                label={formatRequiredLabel("End Date *")}
                                color={'secondary'}
                                variant="outlined"
                                size="small"
                                fullWidth
                                InputProps={{ readOnly: true }}
                                InputLabelProps={{ shrink: true }}
                                onClick={(evt) => {
                                    if (!dateRPOpen) setDateRPOpen(true)
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <TimePicker
                                    variant="inline"
                                    inputVariant="outlined"
                                    size="small"
                                    fullWidth
                                    label={formatRequiredLabel("From *")}
                                    placeholder={"HH:MM"}
                                    value={formState.from}
                                    onChange={date => setFormState({ ...formState, from: date })}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <TimePicker
                                    variant="inline"
                                    inputVariant="outlined"
                                    size="small"
                                    fullWidth
                                    label={formatRequiredLabel("To *")}
                                    value={formState.to}
                                    placeholder={"HH:MM"}
                                    onChange={date => setFormState({ ...formState, to: date })}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                value={formState.title}
                                type={'text'}
                                label={formatRequiredLabel("Title *")}
                                color={'secondary'}
                                variant="outlined"
                                size="small"
                                fullWidth
                                name="title"
                                onChange={handleInputChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <OutlinedSelect
                                options={RepeatMode}
                                name="repeat_mode"
                                val={formState.repeat_mode}
                                label={formatRequiredLabel('Repeat Mode *')}
                                variant="outlined"
                                handleChange={(evt) => handleInputChange(evt)}
                                styleOverrides={{ width: '100%', marginTop: 0 }}
                            />
                        </Grid>
                    </Grid>
                    {["Weekly", "Monthly"].includes(formState.repeat_mode) &&
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <DatePicker
                                        variant="inline"
                                        inputVariant="outlined"
                                        size="small"
                                        fullWidth
                                        label={formatRequiredLabel("Event Expiry date *")}
                                        value={formState.expiryDate}
                                        style={{ width: '100%' }}
                                        minDate={dateRange.endDate || new Date()}
                                        onChange={date => setFormState({ ...formState, expiryDate: date })}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                        </Grid>
                    }
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Autocomplete
                                id="combo-box-demo4"
                                value={formState.project}
                                name="project"
                                options={projectList ? projectList : []}
                                getOptionLabel={option => option.name || ''}
                                onChange={(event, newValue) => {
                                    handleChange(newValue, 'project');
                                }}
                                style={{ width: "100%" }}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        label={formatRequiredLabel('Project *')}
                                        variant="outlined"
                                        size="small"
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <OutlinedSelect
                                options={typeList}
                                name="type"
                                val={formState.type}
                                label={formatRequiredLabel('Type *')}
                                variant="outlined"
                                handleChange={(evt) => handleInputChange(evt)}
                                styleOverrides={{ width: '100%', marginTop: 0 }}
                            />
                        </Grid>
                    </Grid>
                    {formState.type && formState.type === 'Event' ? (
                        <>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <OutlinedSelect
                                        options={eventTypeList}
                                        name="eventType"
                                        val={formState.eventType}
                                        label={formatRequiredLabel('Event Type *')}
                                        variant="outlined"
                                        handleChange={(evt) => handleInputChange(evt)}
                                        styleOverrides={{ width: '100%', marginTop: 0 }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Autocomplete
                                        id="combo-box-demo4"
                                        value={formState.course}
                                        name="course"
                                        disabled={!formState.project.name}
                                        options={dynamicList ? dynamicList : []}
                                        getOptionLabel={option => {
                                            if (!option) return '';
                                            if (formState.eventType === 'Assessment') {
                                                return option.assessment_id__name || ''
                                            } else if (formState.eventType === 'Apprenticeship') {
                                                return option.apprenticeship_id__name || ''
                                            } else {
                                                return option.course_id__name || ''
                                            }
                                        }}
                                        onChange={(event, newValue) => {
                                            handleChange(newValue, 'course');
                                        }}
                                        style={{ width: "100%" }}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label={formatRequiredLabel(`${listTitle} *`)}
                                                variant="outlined"
                                                size="small"
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Autocomplete
                                        id="combo-box-demo4"
                                        value={formState.courseActivity}
                                        name="courseActivity"
                                        options={courseActivityList ? courseActivityList : []}
                                        getOptionLabel={option => option || ''}
                                        onChange={(event, newValue) => {
                                            handleChange(newValue, 'courseActivity');
                                        }}
                                        style={{ width: "100%" }}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label={formatRequiredLabel(`${listTitle} Activity *`)}
                                                variant="outlined"
                                                size="small"
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </>
                    ) : null}
                    {(formState.type === 'Meeting' || formState.type === 'Public Holiday' || formState.courseActivity === 'Virtual Class Project') ? (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    value={formState.url}
                                    type={'text'}
                                    label={formatRequiredLabel("URL *")}
                                    color={'secondary'}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    name="url"
                                    onChange={handleInputChange}
                                />
                            </Grid>
                        </Grid>
                    ) : null}
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                value={formState.note}
                                multiline
                                rows={3}
                                type={'text'}
                                label="Comments"
                                placeholder={"Add note here..."}
                                color={'secondary'}
                                variant="outlined"
                                size="small"
                                fullWidth
                                name="note"
                                onChange={handleInputChange}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose} color="default">
                        Cancel
                    </Button>
                    <Button onClick={handleValidate} color="primary" variant="contained">
                        {btnLoading ? <CircularProgress color='white' size={16} /> : "Add Event"}
                    </Button>
                </DialogActions>
            </Dialog>
            <DateRangePickerModal
                open={dateRPOpen}
                dateRange={dateRange}
                handleClose={() => {
                    setDateRPOpen(false);
                }}
                handleChangeDate={(newDate) => {
                    setStartDate(newDate.startDate ? moment(new Date(newDate.startDate)).format("DD-MM-YYYY") : '');
                    setEndDate(newDate.endDate ? moment(new Date(newDate.endDate)).format("DD-MM-YYYY") : '');
                    setDateRange(newDate);
                }}
            />
        </div >
    );
}
